module.exports = __webpack_public_path__ + "img/gsgroup-logo-white.3665dc61.svg";